import { render, staticRenderFns } from "./newCentrif.vue?vue&type=template&id=a95290f2&scoped=true&"
import script from "./newCentrif.vue?vue&type=script&lang=js&"
export * from "./newCentrif.vue?vue&type=script&lang=js&"
import style0 from "./newCentrif.vue?vue&type=style&index=0&id=a95290f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95290f2",
  null
  
)

export default component.exports